module.exports = __webpack_public_path__ + "img/20200423143441TIM截图20200423140812.af94475c.png";